
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Week from '../../../components/week/Week.jsx'

import Background from '../../../components/background/Background.jsx'

import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx'
import ManagerMenu from '../../../components/managermenu/ManagerMenu.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";


// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';


//Utils
import { checkLogin } from '../../../utils/check-login.js'


function ManagerCalendar() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();



    //// -- at first render :
    useEffect(() => {


        if (checkLogin() === false) {

            navigate(`/manager/login?dest=manager`)
        }

    }, [])
    //// -- 


    const today = dayjs(); // set the date of the current day


    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <ManagerMenu current="calendar" />
                    <Week date={today} manager={true} />



                </div>
            </main>
        </div>
    );
}

export default ManagerCalendar;